// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"8a9e9c4c","178":"d02847e4","304":"8e638727","420":"6009d258","532":"ddd8783f","574":"bbef77b9","629":"609df159","923":"4cb0469a","937":"01a47e3d","948":"eae9ef4f","953":"5fc51622"}[chunkId] + ".chunk.css";
};